module.exports = __webpack_public_path__ + "assets/img/deadpool-404.ff30eb5965cac4741588082cddefb9f6.svg";